// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__thJox","text":"ErrorBoundary_text__Kjv5w"};